<base-index-page
  [config]="baseIndexPageConfig"
  [service]="introducersService"
  [idKey]="'customerId'"
  [autoLoad]="false">

  <div class="row mb-4">
    <div class="col-md-3 col-sm-6">
      <select-field
        [label]="'Introducers Name'"
        [options]="introducerOptions"
        [selectFormControl]="introducerControl"
        [readonly]="isIntroducerSelectLocked"
        (selectionChange)="onIntroducerChange($event)" />
    </div>
    <div class="col-md-3 col-sm-6">
      <input-field
        [label]="'Starting Date'"
        [inputFormControl]="startingDateControl"
        [readonly]="true" />
    </div>
  </div>

</base-index-page>
